import { z } from 'zod';

/* ─── Ввод ──────────────────────────────────────────────────────────────── */

export const createPortalTokenSchema = z.object({
  /** ISO-дата, после которой ссылка перестаёт работать. null — бессрочно. */
  expiresAt: z.string().datetime().nullish(),
});
export type CreatePortalTokenInput = z.infer<typeof createPortalTokenSchema>;

/* ─── Ответы ────────────────────────────────────────────────────────────── */

/**
 * Сведения о выданной ссылке — без самой ссылки.
 *
 * Токен здесь сознательно отсутствует. Он работает как пароль: кто его знает,
 * тот видит начисления, выплаты и долг человека, не входя в систему. Отдавать
 * его при каждом открытии карточки значит превращать «посмотреть, выдана ли
 * ссылка» в «получить действующий ключ и унести с собой».
 */
export interface PortalTokenDto {
  id: string;
  expiresAt: string | null;
  lastViewedAt: string | null;
  viewCount: number;
  createdAt: string;
}

/** Ответ на выпуск ссылки: полный адрес показывается ровно один раз. */
export interface PortalTokenIssuedDto extends PortalTokenDto {
  token: string;
  url: string;
}

export interface PortalPayoutRow {
  id: string;
  title: string;
  kind: string;
  dueDate: string;
  currency: string;
  /** Сумма к выплате с учётом бонусов и штрафов. */
  amountMinor: number;
  paidMinor: number;
  status: string;
  paidAt: string | null;
  /** Бонусы и штрафы внутри начисления — человеку важно видеть, из чего сложилось. */
  adjustments: { type: string; amountMinor: number; note: string | null }[];
}

/**
 * Что видит игрок по ссылке.
 *
 * Только его собственные цифры и ничего про организацию: чужих людей,
 * балансов кошельков и общих оборотов здесь нет.
 */
export interface PortalViewDto {
  workspaceName: string;
  person: {
    nickname: string;
    roleTitle: string | null;
  };
  currency: string;

  accruedMinor: number;
  paidMinor: number;
  /** Остаток: сколько организация ещё должна. Отрицательное — переплата. */
  debtMinor: number;

  upcoming: PortalPayoutRow[];
  history: PortalPayoutRow[];

  generatedAt: string;
}
